import React from 'react';
import type { UseCountryAutocompleteProps } from '@components/moleculs/autocomplete/hooks/types';
import { CountryFlag } from '@components/moleculs/country-flag';
import type { AutocompleteOption, ThemeProps } from '@models/types';
import { Box, useTheme } from '@mui/material';
import type { AutocompleteRenderOptionState } from '@mui/material/Autocomplete/Autocomplete';
import cn from 'classnames';

export const useCountryAutocomplete = (props: UseCountryAutocompleteProps) => {
    const theme = useTheme<ThemeProps>();
    const disabledOptionSuffix = props?.disabledOptionSuffix;

    return {
        renderInputFlag: (countryValue: string) => (
            <React.Fragment>
                {countryValue ? (
                    <CountryFlag
                        name={countryValue}
                        style={{
                            marginLeft: 4,
                            marginRight: 12,
                        }}
                    />
                ) : (
                    <React.Fragment />
                )}
            </React.Fragment>
        ),
        renderFlagOption: (
            { className, ...rest }: React.HTMLAttributes<HTMLLIElement>,
            option: AutocompleteOption<string>,
            selected: AutocompleteRenderOptionState,
        ) => {
            const isDisabled = rest['aria-disabled'];

            return (
                <Box className={cn(className, 'country-checkbox')} component='li' {...rest}>
                    <CountryFlag name={option?.value} />
                    <Box
                        marginLeft='8px'
                        color={selected ? theme.palette.primaryA1 : theme.palette.textLight}
                    >
                        {option?.label}
                        {!!isDisabled && disabledOptionSuffix}
                    </Box>
                </Box>
            );
        },
    };
};
